export const PARTNER_ID_AMEX = 'amex';
export const PARTNER_ID_ENTERPRISE = 'enterprise';
export const PARTNER_ID_BAAS = 'baas';
export const PARTNER_ID_UMPQUA = 'umpqua';
export const PARTNER_ID_ADURO_ADVISORS = 'aduro-advisors';
export const PARTNER_ID_RSM_FAO = 'rsm-fao';
export const PARTNER_ID_RSM_VAR = 'rsm-var';
export const PARTNER_ID_WTI_GLOBAL = 'wti-global';
export const PARTNER_ID_SALES = 'sales';
export const PARTNER_ID_DIRECT = 'direct';
export const PARTNER_ID_NEXONIA = 'nexonia';
export const PARTNER_ID_MACU = 'macu';

export const PARTNER_IDS = [
  PARTNER_ID_AMEX,
  PARTNER_ID_ENTERPRISE,
  PARTNER_ID_SALES,
  PARTNER_ID_BAAS,
  PARTNER_ID_ADURO_ADVISORS,
  PARTNER_ID_MACU,
  PARTNER_ID_RSM_FAO,
  PARTNER_ID_WTI_GLOBAL,
  PARTNER_ID_DIRECT,
  PARTNER_ID_NEXONIA
];

export const SIGNUP_PARTNERS = [
  PARTNER_ID_AMEX,
  PARTNER_ID_ENTERPRISE,
  PARTNER_ID_BAAS,
  PARTNER_ID_UMPQUA,
  PARTNER_ID_ADURO_ADVISORS,
  PARTNER_ID_MACU,
  PARTNER_ID_RSM_FAO,
  PARTNER_ID_RSM_VAR,
  PARTNER_ID_WTI_GLOBAL
];
export type SIGNUP_PARTNERS_TYPE = typeof SIGNUP_PARTNERS[number];

export const MINIMUM_TEN_USERS_LOOKUP_KEY = 'min_ten_users';
export const CUSTOM_MINIMUM_BILLING_LOOKUP_MAP: Record<string, string> = {
  [PARTNER_ID_ADURO_ADVISORS]: MINIMUM_TEN_USERS_LOOKUP_KEY,
  [PARTNER_ID_MACU]: MINIMUM_TEN_USERS_LOOKUP_KEY
};

export const PARTNERS_SUPPORTING_NEW_SIGNUP_FLOW = [
  PARTNER_ID_AMEX,
  PARTNER_ID_UMPQUA,
  PARTNER_ID_ADURO_ADVISORS,
  PARTNER_ID_MACU,
  PARTNER_ID_RSM_FAO,
  PARTNER_ID_RSM_VAR,
  PARTNER_ID_WTI_GLOBAL
];

export const PARTNER_TO_CHANNEL_MAP = {
  [PARTNER_ID_AMEX]: `${PARTNER_ID_AMEX}&cards=hide`,
  [PARTNER_ID_UMPQUA]: 'direct&cards=hide',
  [PARTNER_ID_ADURO_ADVISORS]: `${PARTNER_ID_ADURO_ADVISORS}&cards=hide`,
  [PARTNER_ID_MACU]: `${PARTNER_ID_MACU}&cards=hide`,
  [PARTNER_ID_RSM_FAO]: `${PARTNER_ID_RSM_FAO}&billing_plan=spend_annual_contract&implementation=guided`,
  [PARTNER_ID_RSM_VAR]: `${PARTNER_ID_RSM_VAR}&billing_plan=spend_annual_contract&implementation=guided`,
  [PARTNER_ID_WTI_GLOBAL]: `${PARTNER_ID_WTI_GLOBAL}&cards=hide`
};
